import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./loading-screen.less";
export default function LoadingScreen({ isLoading }) {
    if (!isLoading) {
        return null;
    }
    return (_jsxs("div", { className: "HGU__loading-screen", children: [_jsx("div", { className: "HGU__loading-spinner" }), _jsx("p", { className: "HGU__loading-text", children: "Loading..." })] }));
}
